module.exports = __webpack_public_path__ + "static/media/banner4-mobile2-2024.dacd8e77.jpg";